function getUserIp() {
    // TODO-001 Implement functionality to return user's IP
    return '148.128.148.96'
}

function getToken() {
    return window.location.pathname.split('/')[2];
}

export {
    getToken,
    getUserIp
}
